<template>
  <div>
    <div class="pc">
      <div class="banner1">
        <div class="daoyu" style="padding-top: 524px">
          <p style="font-size: 1.1em">
            为进一步倾听市民呼声、汲取群众智慧，使民生实事项目设置更加准确地反映人民群众所盼所需，提高政府依法、民主、科学决策水平，经市政府同意，决定在全市范围内公开征集2024年度瑞安市民生实事建议项目。
          </p>
        </div>
      </div>
      <div class="w1000">
        <div class="txt">
          <div class="w490 fl">
            <h3>征集时间</h3>
            <p>
              <b>自通告发布之日起至2023年10月31日止。</b>
            </p>
            <h3>征集方式</h3>
            <p>
              <span style="padding: 0"><img src="../../assets/proposal/images/ewm.png" width="100%" /><i>民生实事征集二维码</i></span>
              <b>1.网络征集。</b><br />
              直接登录“中国瑞安”（www.ruian.gov.cn）,点击“2024年度瑞安市民生实事建议项目征集”进入留言区填写建议内容；关注“瑞安发布”微信公众号，点击链接填报建议内容;手机用户可扫描民生实事征集二维码直接参与征集。
            </p>
            <p><b>2.热线征集。</b>拨打“12345”政务服务热线、“81890000”社会服务热线，参与“民生实事建议项目电话征集”活动，提出意见建议。</p>
            <p>
              <b>3.信函征集。</b
              >发送电子邮件至rdzxgzllk@163.com；或邮寄信函至瑞安市人民政府办公室，地址：瑞安市安阳街道万松东路156号市政大院，邮编：325200，信封注明“民生实事征集”字样，截止日期以邮戳为准。
            </p>
            <p>希望广大市民和社会各界有识之士踊跃参与，积极建言献策。同时鼓励项目建议者提供真实姓名、单位、联系电话，以便进一步联系沟通。</p>
          </div>
          <div class="w470 fr">
            <h3>征集内容</h3>
            <p>
              民生实事建议项目要突出“补短板、惠民生”，做到聚焦民生、普惠共享、量化可行、群众满意，原则上项目要当年完成、当年见效。主要围绕公共教育、医疗服务、文化体育、交通出行、食药安全、环境治理、就业创业、住房保障、养老助残、社保救助、公共安全、便民服务等民生领域的意见建议。
            </p>
            <h3>征集要求</h3>
            <p>
              （一）体现普惠性。征集的民生实事建议项目应具有公益性，项目受益面要广，尽可能涵盖较大的社会群体。<br />
              （二）注重实效性。征集的民生实事建议项目应围绕群众最关心、最盼望、最急需解决的现实问题，项目的实施能让群众看得见、摸得着、易感知、得实惠。<br />
              （三）突出可行性。征集的民生实事建议项目应立足瑞安实际和财力承受能力，原则上做到当年实施、当年完成、当年见效或取得阶段性成效。<br />
              （四）目标可量化。征集的民生实事建议项目应有清晰的年度定量目标，便于监督、考核、评价。<br />
            </p>
            <p style="text-align: right; padding: 15px 0"><img src="../../assets/proposal/images/pic01.jpg" /></p>
          </div>
        </div>
      </div>
    </div>

    <div class="sj">
      <div class="banner2"><img src="../../assets/proposal/images/banner2.jpg" width="100%" /></div>
      <div class="txt">
        <h3>征集时间</h3>
        <p>
          <b>自通告发布之日起至2023年10月31日止。</b>
        </p>
        <h3>征集内容</h3>
        <p>
          民生实事建议项目要突出“补短板、惠民生”，做到聚焦民生、普惠共享、量化可行、群众满意，原则上项目要当年完成、当年见效。主要围绕公共教育、医疗服务、文化体育、交通出行、食药安全、环境治理、就业创业、住房保障、养老助残、社保救助、公共安全、便民服务等民生领域的意见建议。
        </p>
        <div class="btn1" style="width: 45%; float: left; margin: 5% 0">
          <a href="#" @click="showYq">征集要求<font>（点击查看）</font></a>
        </div>
        <van-popup
          v-model="yqShow"
          :style="{ width: '90%', height: '50%', background: '#fefefe', border: '6px solid rgb(74 71 71 / 80%)', borderRadius: '4px' }"
        >
          <div style="padding: 1em; font-size: 1.2em; text-align: justify; color: #333">
            （一）体现普惠性。征集的民生实事建议项目应具有公益性，项目受益面要广，尽可能涵盖较大的社会群体。<br /><br />
            （二）注重实效性。征集的民生实事建议项目应围绕群众最关心、最盼望、最急需解决的现实问题，项目的实施能让群众看得见、摸得着、易感知、得实惠。<br /><br />
            （三）突出可行性。征集的民生实事建议项目应立足瑞安实际和财力承受能力，原则上做到当年实施、当年完成、当年见效或取得阶段性成效。<br /><br />
            （四）目标可量化。征集的民生实事建议项目应有清晰的年度定量目标，便于监督、考核、评价。<br />
          </div>
        </van-popup>
        <div class="btn2" style="width: 45%; float: right; margin: 5% 0">
          <a href="#" @click="showFs">征集方式<font>（点击查看）</font></a>
        </div>
        <van-popup
          v-model="fsShow"
          :style="{ width: '90%', height: '70%', background: '#fefefe', border: '6px solid rgb(74 71 71 / 80%)', borderRadius: '4px' }"
        >
          <div style="padding: 1em; font-size: 1.2em; text-align: justify; color: #333">
            （一）网络征集。直接登录“中国瑞安”（www.ruian.gov.cn）,点击“2024年度瑞安市民生实事建议项目征集”进入留言区填写建议内容；关注“瑞安发布”微信公众号，点击链接填报建议内容;手机用户可扫描民生实事征集二维码直接参与征集。<br /><br />
            （二）热线征集。拨打“12345”政务服务热线、“81890000”社会服务热线，参与“民生实事建议项目电话征集”活动，提出意见建议。<br /><br />
            （三）信函征集。发送电子邮件至rdzxgzllk@163.com；或邮寄信函至瑞安市人民政府办公室，地址：瑞安市安阳街道万松东路156号市政大院，邮编：325200，信封注明“民生实事征集”字样，截止日期以邮戳为准。<br /><br />
            希望广大市民和社会各界有识之士踊跃参与，积极建言献策。同时鼓励项目建议者提供真实姓名、单位、联系电话，以便进一步联系沟通。<br />
          </div>
        </van-popup>
      </div>
    </div>

    <div class="blue">
      <div class="w1000">
        <h3>
          民生实事征集留言区<span>（带 <b>*</b> 为必填项）</span>
        </h3>

        <div class="w490 fl">
          <div class="div1">
            <label>建议项目<b>*</b></label>
            <select v-model="form.proposalPro" class="input-text" autocomplete="off">
              <option value="公共教育">公共教育</option>
              <option value="医疗服务">医疗服务</option>
              <option value="文化体育">文化体育</option>
              <option value="交通出行">交通出行</option>
              <option value="食药安全">食药安全</option>
              <option value="环境治理">环境治理</option>
              <option value="就业创业">就业创业</option>
              <option value="住房保障">住房保障</option>
              <option value="养老助残">养老助残</option>
              <option value="社保救助">社保救助</option>
              <option value="公共安全">公共安全</option>
              <option value="便民服务">便民服务</option></select
            ><span style="color: red" id="chk_jyxm"></span>
          </div>
          <div class="div1">
            <label>意见建议<b>*</b></label>
            <textarea class="textarea" autocomplete="off" v-model="form.proposalContent"></textarea><span style="color: red" id="chk_yjjy"></span>
          </div>

          <p style="color: #ffcb71; text-align: right"><b>*</b>字数限定500字以内</p>
        </div>
        <div class="w490 fr">
          <div class="div1">
            <label>姓名</label><input type="text" class="input-text" autocomplete="off" v-model="form.name" /><span
              style="color: red"
              id="chk_name"
            ></span>
          </div>
          <div class="div1">
            <label>单位</label><input type="text" class="intxt" autocomplete="off" v-model="form.dept" /><span
              style="color: red"
              id="chk_danwei"
            ></span>
          </div>
          <div class="div1">
            <label>联系电话</label><input type="text" class="intxt" autocomplete="off" v-model="form.mobile" /><span
              style="color: red"
              id="chk_lxdh"
            ></span>
          </div>
          <p style="color: #ffcb71"><b>*</b>鼓励项目建议者提供真实姓名、单位、联系电话，以便进一步联系沟通。</p>
        </div>
        <div style="clear: both"></div>
        <div class="div2">
          <input type="submit" class="coolbg" value="提交" @click="onSubmit" />
        </div>
      </div>
    </div>

    <div class="footer">&copy; 瑞安市人民政府办公室 版权所有</div>
  </div>
</template>
<script>
import { Toast } from 'vant';
import { add } from '@/api/proposalApi';
import myValitar from '@/config/myValitar';

export default {
  name: 'proposalCollect',
  data() {
    return {
      form: {
        name: '',
        mobile: '',
        dept: '',
        proposalPro: '',
        proposalContent: ''
      },
      yqShow: false,
      fsShow: false
    };
  },
  created() {},
  mounted() {
    this.addCssLink(
      'http://zjjcmspublic.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/jcms_files/jcms1/web2631/site/images/39705/hanweb.css'
    );
    this.addCssLink('http://zjjcmspublic.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/jcms_files/jcms1/web2631/site/images/39705/index.css');
    this.addJsLink('//zjjcmspublic.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/jcms_files/jcms1/web2631/site/script/0/2108131546577094.js');
    this.addJsLink(
      '//zjjcmspublic.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/jcms_files/jcms1/web2631/site/script/1130/2012151531208989.js'
    );
    this.addJsLink(
      'https://zjjcmspublic.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/jcms_files/jcms1/web2631/site/script/1130/2012151605167144.js'
    );
  },
  methods: {
    showYq() {
      this.yqShow = true;
    },
    showFs() {
      this.fsShow = true;
    },
    onSubmit() {
      if (!this.form.proposalPro) {
        Toast.fail('请先选择建议项目');
        return;
      }
      if (!this.form.proposalContent) {
        Toast.fail('请先填写意见建议');
        return;
      }
      if (this.form.proposalContent.length > 550) {
        Toast.fail('字数限定500字以内');
        return;
      }
      if (this.form.mobile && !myValitar.validatorPhoneMobile(this.form.mobile)) {
        Toast.fail('请输入13位手机号或05**-********的座机号');
        return;
      }
      let that = this;
      let toast = Toast.loading({
        message: '提交中...',
        forbidClick: true,
        loadingType: 'spinner'
      });
      add(this.form).then((response) => {
        toast.clear();
        if (response.code == 200) {
          Toast.success('提交成功');
          that.form = {
            name: '',
            mobile: '',
            dept: '',
            proposalPro: '',
            proposalContent: ''
          };
        } else {
          Toast.fail('提交失败，请稍后再试');
        }
      });
    },
    addCssLink(url) {
      let link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.href = url;
      document.head.appendChild(link);
    },
    addJsLink(url) {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      document.body.appendChild(script);
    }
  }
};
</script>
<style lang="less" scoped>
@import '../../assets/css/common.css';
@import '../../assets/proposal/css/style.css';
</style>
